import { render, staticRenderFns } from "./one.vue?vue&type=template&id=64b2da22&scoped=true"
import script from "./one.vue?vue&type=script&lang=ts"
export * from "./one.vue?vue&type=script&lang=ts"
import style0 from "./one.vue?vue&type=style&index=0&id=64b2da22&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b2da22",
  null
  
)

export default component.exports